/** Creator draft, or the launched study's results. */
export type StudyFrameSurface = "draft" | "results";

export interface SessionSelection {
  kind: "sources" | "runs" | "rooms" | "studies" | "study" | "quick_study";
  token?: string;
  /** Set when `kind` is `study`. */
  studySurface?: StudyFrameSurface;
}

export interface SessionState {
  selection: SessionSelection;
  roomTokens: Array<string>;
}

export type SessionAction =
  | { type: "select"; selection: SessionSelection }
  | { type: "room_created"; token: string }
  | { type: "reset" };

export function sessionReducer(
  state: SessionState,
  action: SessionAction,
): SessionState {
  switch (action.type) {
    case "select":
      return { ...state, selection: action.selection };
    case "room_created":
      return {
        selection: { kind: "rooms", token: action.token },
        roomTokens: state.roomTokens.includes(action.token)
          ? state.roomTokens
          : [...state.roomTokens, action.token],
      };
    case "reset":
      return { selection: { kind: "runs" }, roomTokens: [] };
  }
}
